export const config = {
    std: {
        api: 'https://teamshub-dev.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    },
    uat: {
        api: 'https://teamshub-uat.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    },
    prod: {
        api: 'https://teamshub.fifa.org/api',
        field: {
            tournaments: {
                name: 'tournament',
                id: 'tournamentId'
            },
            roles: {
                name: 'roles',
                id: 'roleIds'
            },
            teams: {
                name: 'teams',
                id: 'teamIds'
            }
        }
    }
}